import { render, staticRenderFns } from "./AddLHTSupplier.vue?vue&type=template&id=5a636af4&scoped=true&"
import script from "./AddLHTSupplier.vue?vue&type=script&lang=js&"
export * from "./AddLHTSupplier.vue?vue&type=script&lang=js&"
import style0 from "./AddLHTSupplier.vue?vue&type=style&index=0&id=5a636af4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a636af4",
  null
  
)

export default component.exports